var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59094 6.99994L13.0441 2.54681C13.2554 2.33584 13.3743 2.04955 13.3745 1.75093C13.3748 1.45231 13.2564 1.16581 13.0455 0.954469C12.8345 0.743124 12.5482 0.624244 12.2496 0.62398C11.951 0.623717 11.6645 0.742091 11.4531 0.953062L7 5.40619L2.54687 0.953062C2.33553 0.741718 2.04888 0.622986 1.75 0.622986C1.45111 0.622986 1.16447 0.741718 0.953123 0.953062C0.741779 1.16441 0.623047 1.45105 0.623047 1.74994C0.623047 2.04882 0.741779 2.33547 0.953123 2.54681L5.40625 6.99994L0.953123 11.4531C0.741779 11.6644 0.623047 11.9511 0.623047 12.2499C0.623047 12.5488 0.741779 12.8355 0.953123 13.0468C1.16447 13.2582 1.45111 13.3769 1.75 13.3769C2.04888 13.3769 2.33553 13.2582 2.54687 13.0468L7 8.59369L11.4531 13.0468C11.6645 13.2582 11.9511 13.3769 12.25 13.3769C12.5489 13.3769 12.8355 13.2582 13.0469 13.0468C13.2582 12.8355 13.3769 12.5488 13.3769 12.2499C13.3769 11.9511 13.2582 11.6644 13.0469 11.4531L8.59094 6.99994Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close_modal.c045ab22edf35e87105fa084e2b76ea0.svg";
export { ForwardRef as ReactComponent };